import { useEffect } from 'react';
import { useGetEssentailDataQuery, useUpdateEssentailDocsMutation } from 'src/services/EssentialDocs';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useEssentialDocs = () => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const dispatch = useAppDispatch();

  const {
    data: essentialDocsQueryData,
    error: getEssentialDocsError,
    refetch: getEssentialDocsQueryData
  } = useGetEssentailDataQuery({
    site_id: siteId,
    study_id: studyId,
    country,
    application
  });

  const [updateEssentialDocs, { data: updateEssentialDocsData, error: updateEssentialDocsError }] =
    useUpdateEssentailDocsMutation();

  useEffect(() => {
    if (updateEssentialDocsError || getEssentialDocsError) {
      updateUserAccess(updateEssentialDocsError || getEssentialDocsError, dispatch);
    }
  }, [updateEssentialDocsError]);

  return {
    essentialDocsQueryData,
    getEssentialDocsError,
    getEssentialDocsQueryData,
    updateEssentialDocs,
    updateEssentialDocsData
  };
};
